<template>
  <canvas id="matrix"></canvas>
</template>

<script>
export default {
  mounted() {
    const canvas = document.getElementById('matrix');
    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const chars = "Professional Guidance for Crypto Fraud & Digital Asset Loss";
    const fontSize = 14;

    const columns = canvas.width / fontSize;

    const drops = Array(Math.floor(columns)).fill(1).map(() =>
      Math.floor(Math.random() * (canvas.height / fontSize))
    );

    const draw = () => {
      ctx.fillStyle = "rgba(5, 8, 20, 0.05)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "#00e5ff";
      ctx.font = fontSize + "px monospace";
      for (let i = 0; i < drops.length; i++) {
        const text = chars[Math.floor(Math.random() * chars.length)];
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) drops[i] = 0;
        drops[i]++;
      }
    };
    this.interval = setInterval(draw, 50);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    window.removeEventListener('resize', this.resizeCanvas);
  }
}
</script>

<style scoped>
#matrix {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
</style>